import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { WHITE, DARK_GREY, ALMOST_WHITE, ACCENT_BLUE } from "constants/colors";

export default makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      backgroundColor: DARK_GREY,
      color: `${ALMOST_WHITE} !important`,
      borderRadius: "4px",
      width: "100%",
      "&:hover,&:focus": {
        border: `1px solid ${ACCENT_BLUE}`,
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    dropdownLabel: {
      backgroundColor: "#363D47",
      borderRadius: "4px",
      fontSize: "14px",
    },
    labelItem: {
      position: "relative",
      fontSize: "14px !important",
      color: "#FFFFFF",
      minHeight: "auto",
    },
    lebelLegth: {
      position: "absolute",
      right: "30px",
      color: "#737980 !important",
      minHeight: "auto",
    },
    label: {
      fontStretch: "normal",
      letterSpacing: "normal",
      zIndex: 200,
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "14px !important",
      lineHeight: "16px",
      color: "#8A9199 !important",
      minHeight: "0px !important",
    },
    select: { 
      color: WHITE,
      zIndex: 100,
      '&::after': {
        borderBottom: '2px solid #90caf9'
      },
      '&::before': {
        borderBottom: '2px solid #596c8d'
      },
      "& .MuiSvgIcon-root": {
        color: WHITE,
      },
      '&:hover:not($disabled):before': {
        borderBottom: '2px solid #90caf9'

      },
    },
    classLabel:{
     color: '#CFD9E6',
     "&.Mui-focused": {
      color: "#CFD9E6"
    }
    },
  
    cssFocused:{

    },
    cssOutlinedInput:{

    },
    selectItem: {},
    brand: {},
    selected: {},
    menuItemSelected: {},
  })
);
